import React from 'react'
import Moment from 'react-moment'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Info } from 'components/common/form/modules/Info';

const InventoryTableBody: React.FC<{ [label: string]: any }> = (props: any) => {

    const handleOnDragEnd = (result: any) => {
        if (!result.destination) {
            return
        }
        const items = JSON.parse(JSON.stringify(props.items))
        const [reorderedItem] = items.splice(result.source.index, 1)
        items.splice(result.destination.index, 0, reorderedItem)
        props.setInventory(items)
    }

    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: "none",
        padding: 8 * 2,
        margin: `0 0 8px 0`,
        background: isDragging ? "lightgreen" : "white",
        ...draggableStyle
    });

    const getListStyle = isDraggingOver => ({
        background: isDraggingOver ? "#F8F8F8" : "white",
        padding: 8,
        width: '100%',
    });

    return <>
        <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <tbody
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {props.items.map((item, index) => {
                            let fpObj: any = null;
                            if (props.floorplan) {
                                fpObj = props.floorplan.inventoryMap.find((i: any) => {
                                    return i.inventoryItemId.toString().trim() === item.id.toString().trim()
                                })
                            }
                            return <Draggable key={item.id} draggableId={item.id} index={index}>
                                {(p, s) => (
                                    <tr
                                        ref={p.innerRef}
                                        {...p.draggableProps}
                                        {...p.dragHandleProps}
                                        style={
                                            getItemStyle(s.isDragging, p.draggableProps.style)
                                        }
                                    >
                                        <td onClick={() => props.openInventoryUpdateModal(item)}>
                                            <div className='sexyBlack' >
                                                {item.name}
                                            </div>
                                            <div style={{ fontSize: '11px', wordWrap: 'break-word' }}>
                                                {
                                                    item.description && item.description.length > 50
                                                        ? item.description.substr(0, 49) + ' . . .'
                                                        : ''
                                                }
                                            </div>
                                            {
                                                item.autoSale || item.endTime
                                                    ? <div style={{ fontSize: '10px', color: props.isInSalesPeriod(item) ? '#1931b9' : '#d63191' }}>
                                                        {
                                                            item.autoSale
                                                                ? <>
                                                                    <Moment format="D MMM 'YY, " >
                                                                        {Number(new Date(
                                                                            item.startTime.year,
                                                                            item.startTime.month - 1,
                                                                            item.startTime.day,
                                                                            item.startTime.PM ? item.startTime.hour + 12 : item.startTime.hour,
                                                                            item.startTime.minute
                                                                        ))}
                                                                    </Moment>
                                                                    <Moment format="hh:mm A">
                                                                        {Number(new Date(
                                                                            item.startTime.year,
                                                                            item.startTime.month - 1,
                                                                            item.startTime.day,
                                                                            item.startTime.PM ? item.startTime.hour + 12 : item.startTime.hour,
                                                                            item.startTime.minute
                                                                        ))}
                                                                    </Moment>
                                                                    <br />To<br />
                                                                </>
                                                                : null
                                                        }
                                                        {
                                                            item.endTime && !item.autoSale
                                                                ? <div>Bidding Ends</div>
                                                                : null
                                                        }
                                                        <Moment format="D MMM 'YY, ">
                                                            {Number(new Date(
                                                                item.endTime.year,
                                                                item.endTime.month - 1,
                                                                item.endTime.day,
                                                                (item.endTime.PM ? item.endTime.hour + 12 : item.endTime.hour),
                                                                item.endTime.minute
                                                            ))}
                                                        </Moment>
                                                        <Moment format="hh:mm A">
                                                            {Number(new Date(
                                                                item.endTime.year,
                                                                item.endTime.month - 1,
                                                                item.endTime.day,
                                                                (item.endTime.PM ? item.endTime.hour + 12 : item.endTime.hour),
                                                                item.endTime.minute
                                                            ))}
                                                        </Moment>
                                                    </div>
                                                    : null
                                            }
                                        </td>
                                        <td onClick={() => props.openInventoryUpdateModal(item)}>
                                            <div className='sexyBlack'>
                                                ${(item.price / 100).toFixed(2)}
                                            </div>
                                            <div style={{ fontSize: '11px' }}>
                                                {
                                                    fpObj && fpObj.bid
                                                        ? <Info>Minimum Bid</Info>
                                                        : <Info>
                                                            You earn  ${
                                                                props.user.isAdmin || props.user.id.toString().trim() === props.createdBy.toString().trim()
                                                                    ? (item.price / 100).toFixed(2)
                                                                    : (item.commission / 100).toFixed(2)
                                                            }
                                                        </Info>
                                                }
                                            </div>
                                        </td>
                                        <td onClick={() => props.openInventoryUpdateModal(item)}>{item.bought}</td>
                                        <td onClick={() => props.openInventoryUpdateModal(item)}>{item.quantity}</td>
                                        {
                                            props.user.id.toString().trim() === props.createdBy.toString().trim() || props.user.isAdmin
                                                ? null
                                                : <td>{item.allocatedBy}</td>
                                        }
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={!item.sell}
                                                onChange={e => props.handleSellChange(item.id, !item.sell)}
                                                style={{ height: '10px', width: '10px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </Draggable>
                        })}
                        {provided.placeholder}
                    </tbody>
                )}
            </Droppable>
        </DragDropContext>
    </>
}

export default InventoryTableBody





// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/InventoryTableBody.tsx